

import { Component, Vue, Watch } from 'vue-property-decorator';
import HomeData from '~/components/Data.vue';
import CHeader from '~/components/Device/ExpandingItems/Header.vue';
import Owners from '~/components/Home/Owners.vue';
import RemoveUserButton from '~/components/User/RemoveUserButton.vue';
import { HomesModule } from '~/store/modules/homes';
import { HomesEnergyModule } from '~/store/modules/homesEnergy';
import { HomesSecurityModule } from '~/store/modules/homesSecurity';
import { UserModule } from '~/store/modules/user';

@Component({
    components: {
        HomeData,
        RemoveUserButton,
        Owners,
        CHeader,
    },
})
export default class Home extends Vue {
    openedPanels: number[] = [];

    @Watch('currentHomeId', { immediate: true })
    handleOpenedPanels() {
        // there are 3 panels to open
        this.openedPanels = [...Array(3).keys()].map((k, i) => i);
    }

    get getUserTopologyScope() {
        return UserModule.getUserTopologyScope;
    }

    get currentHomeId() {
        return HomesModule.currentHomeId;
    }

    get currentHomeInfo() {
        return HomesModule.homeInfo;
    }

    get currentUser() {
        return { mail: UserModule.prefixedUserMail, id: UserModule.id };
    }

    get hasSecurity() {
        return HomesModule.hasSecurity;
    }

    get hasEnergy() {
        return HomesModule.hasEnergy;
    }

    get infoGeneral() {
        return HomesSecurityModule.infoGeneral;
    }

    get infoPresence() {
        return HomesSecurityModule.infoPresence;
    }
    get infoWelcome() {
        return HomesSecurityModule.infoWelcome;
    }
    get infoSiren() {
        return HomesSecurityModule.infoSiren;
    }

    get infoDoorbell() {
        return HomesSecurityModule.infoDoorbell;
    }

    get infoEnergy() {
        return HomesEnergyModule.infos;
    }

    get hasPresence() {
        return HomesSecurityModule.currentSecurityHome && HomesSecurityModule.currentSecurityHome.NOC;
    }

    get hasSiren() {
        return HomesSecurityModule.hasSiren;
    }

    get hasWelcome() {
        return HomesSecurityModule.currentSecurityHome && HomesSecurityModule.currentSecurityHome.NACamera;
    }

    get hasDoorbell() {
        return HomesSecurityModule.currentSecurityHome && HomesSecurityModule.currentSecurityHome.NDB;
    }

    get home() {
        return HomesModule.currentHome;
    }

    get hasUserSelected() {
        return UserModule.id && UserModule.id !== '';
    }
}
